import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { getFAQsUseCase } from '../../../core/domain/faqs/usecases/faqs.usecase';
import { Banner, FAQ } from '@/core/domain/faqs/models/faqs-data.model';
import { SsrService } from '@/common/services/ssr/ssr.service';

@Component({
    selector: 'fe-faq-page',
    templateUrl: './faq-page.component.html',
    styleUrls: ['./faq-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FaqPageComponent implements OnInit {
    breadcrumbs = [
        { label: 'fe_breadcrumb_client_support', url: 'contact-us-and-faqs' },
        { label: 'fe_breadcrumb_help_faq', url: 'questions' },
    ];

    public faqs?: FAQ[];

    public banner?: Banner;

    constructor(
        private readonly getFAQsUseCase: getFAQsUseCase,
        public ssr: SsrService,
    ) {}

    ngOnInit(): void {
        this.getFAQs();
    }

    public getFAQs(): void {
        this.getFAQsUseCase.execute().subscribe((faqs) => {
            this.faqs = faqs.data?.faqs;
            this.banner = faqs.data?.banner;
        });
    }
}
